export const formatNumber = (value: string | number) => 
    (value as string).replace(/[^\d-]/g, "");

